export const formFields = [
  {
    section: "DSC Schedule Name",
    name: "dscScheduleName",
    label: "Schedule",
    fieldLabel: "DSC Schedule Name",
    type: "text",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [5, 15],
  },
  {
    section: "DSC Schedule Name",
    name: "wrkDescription25",
    label: "Description",
    fieldLabel: "Wrk Description 25",
    type: "text",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [5, 27],
  },
  {
    section: "DSC Schedule Name",
    name: "dsdStepNumber",
    label: "Step Number",
    fieldLabel: "DSD Step Number",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [6, 15],
  },
  {
    section: "DSC Schedule Name",
    name: "depFromDate",
    label: "From Date",
    fieldLabel: "From Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 13],
  },
  {
    section: "DSC Schedule Name",
    name: "depThruDate",
    label: "Thru Date",
    fieldLabel: "Thru Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 38],
  },
  {
    section: "DSC Schedule Name",
    name: "depStatus",
    label: "Status",
    fieldLabel: "Status (A/I)",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 1, message: "MAXLENGTH_1" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [10, 15],
  },
  {
    section: "Patient Pay Schedule (Header)",
    name: "depPharmPatPaySchedule",
    label: "Pharmacy",
    fieldLabel: "Pharmacy",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "external",
      viewType: "external",
      fieldMapping: {
        default: [
          {
            source: "depPharmPatPaySchedule",
            target: "ps3PatientPaySchName",
            legacy: "ps3PatientPaySchName",
          },
          {
            source: "wrkDescription251",
            target: "ps3PatientPaySchDesc",
            legacy: "ps3PatientPaySchDesc",
          },
        ],
      },
      appName: "PATIENT_PAY",
      pageName: "PATIENT_PAY_SCHEDULE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 13],
  },
  {
    section: "Patient Pay Schedule (Header)",
    name: "wrkDescription251",
    label: "",
    fieldLabel: "Wrk Description 25 1",
    type: "text",
    options: {
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [11, 27],
  },
  {
    section: "Patient Pay Schedule (Header)",
    name: "depClientPatPaySchedule",
    label: "Client",
    fieldLabel: "Client",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "external",
      viewType: "external",
      fieldMapping: {
        default: [
          {
            source: "depClientPatPaySchedule",
            target: "ps3PatientPaySchName",
            legacy: "ps3PatientPaySchName",
          },
          {
            source: "wrkDescription252",
            target: "ps3PatientPaySchDesc",
            legacy: "ps3PatientPaySchDesc",
          },
        ],
      },
      appName: "PATIENT_PAY",
      pageName: "PATIENT_PAY_SCHEDULE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 13],
  },
  {
    section: "Patient Pay Schedule (Header)",
    name: "wrkDescription252",
    label: "",
    fieldLabel: "Wrk Description 25 2",
    type: "text",
    options: {
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [12, 27],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "Added",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "Changed",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 42],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "User",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 61],
  },
];
